import styled from '@emotion/styled';
import {colors, fonts} from 'ui/config';
import {Img} from 'ui';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  width: 157,
  minWidth: 157,
  height: 154,
  backgroundColor: colors.white,
  marginBottom: 20,
  marginRight: 20,
});

export const Image = styled(Img)({
  display: 'flex',
  width: 110,
  height: 84,
  objectFit: 'contain',
  marginRight: 0,
});

export const GiftPrice = styled('div')({
  fontFamily: fonts.title,
  color: colors.caramel,
  fontSize: 26,
  lineHeight: '28px',
  fontWeight: 'bold',
  display: 'flex',
  margin: '10px 0 12px',
});

export const Units = styled(GiftPrice)({
  fontSize: 16,
  lineHeight: '19px',
  margin: 0,
  marginLeft: 5,
});
